import Api from "./Api";
import { WidgetTourStep } from "../types";

export default class WidgetTourStepsController extends Api {
  static create(widgetId: string, tourId: string, step: Partial<WidgetTourStep>) {
    return fetch(`/api/widgets/${widgetId}/tours/${tourId}/steps`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ step }),
    }).then((res) => res.json());
  }

  static update(widgetId: string, tourId: string, step: Partial<WidgetTourStep>) {
    return fetch(`/api/widgets/${widgetId}/tours/${tourId}/steps/${step.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ step }),
    }).then((res) => res.json());
  }

  static delete(widgetId: string, tourId: string, id: string) {
    return fetch(`/api/widgets/${widgetId}/tours/${tourId}/steps/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }
}
